export function initSubnav(menuItem) {
  setSubnavWidth(menuItem);

  window.addEventListener("optimizedResize", () => {
    setSubnavWidth(menuItem);
  });
}

function setSubnavWidth(menuItem) {
  // Nothing to do if it's not horizontal
  if (!menuItem.classList.contains("submenu-horizontal")) {
    return;
  }

  const subMenuContainer = menuItem.querySelector(".js-dropdown-menu");

  if (!subMenuContainer) {
    return;
  }

  const subnavContainer = document.querySelector(".js-subnav-container");

  // Set correct width for the dropdown
  subMenuContainer.style.width = `${subnavContainer.offsetWidth}px`;
  const transformX = computeDistance(subMenuContainer, subnavContainer);
  subMenuContainer.style.transform = `translateX(${transformX})`;
}

function computeDistance(subMenuContainer, subnavContainer) {
  const containerLeft = subMenuContainer.getBoundingClientRect().left;
  const subnavLeft = subnavContainer.getBoundingClientRect().left;

  return `-${containerLeft - subnavLeft}px`;
}
